export default __webpack_public_path__ + "static/banner-back-6cc12b6f7634d7bd898049dae0086374.webp";